/**
 * Minimal ULID. Time-ordered and collision-safe, which matters because the
 * server dedupes on this value and the edge KV keys sort by it.
 */
const B32 = '0123456789ABCDEFGHJKMNPQRSTVWXYZ';

export function ulid(now: number = Date.now()): string {
  let ts = '';
  for (let i = 9; i >= 0; i--) {
    ts = B32[now % 32] + ts;
    now = Math.floor(now / 32);
  }
  const rnd = crypto.getRandomValues(new Uint8Array(16));
  let tail = '';
  for (let i = 0; i < 16; i++) tail += B32[rnd[i] % 32];
  return ts + tail;
}
